/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Rate_LimitedInputs */



/**
* | output |
* | --- |
* | "Too many attempts. Wait a minute and try again." |
*
* @param {Login_Error_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_error_rate_limited = /** @type {((inputs?: Login_Error_Rate_LimitedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Rate_LimitedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Te veel pogingen. Wacht een minuut en probeer opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trop de tentatives. Attendez une minute et réessayez.")
	return /** @type {LocalizedString} */ ("Too many attempts. Wait a minute and try again.")
});